<template>
    <svg
        id="mastercard-svgrepo-com"
        xmlns="http://www.w3.org/2000/svg"
        :width="30"
        :height="30"
        viewBox="0 0 48.499 37.633"
    >
        <path
            id="Path_2258"
            data-name="Path 2258"
            d="M19.321,174.173v-2.5a1.465,1.465,0,0,0-1.582-1.582,1.642,1.642,0,0,0-1.415.708,1.456,1.456,0,0,0-1.332-.708,1.345,1.345,0,0,0-1.166.583v-.5h-.874v4h.874v-2.206c0-.708.375-1.041.957-1.041s.874.375.874,1.041v2.206h.874v-2.206a.921.921,0,0,1,.957-1.041c.583,0,.874.375.874,1.041v2.206Zm12.947-4H30.853V168.97h-.874v1.207h-.791v.791h.791V172.8c0,.916.375,1.457,1.374,1.457a2.328,2.328,0,0,0,1.082-.291l-.25-.749a1.37,1.37,0,0,1-.749.208c-.416,0-.583-.25-.583-.666v-1.79h1.415v-.791Zm7.41-.083a1.173,1.173,0,0,0-1.041.583v-.5h-.874v4h.874v-2.248c0-.666.291-1.041.833-1.041a2.437,2.437,0,0,1,.541.083l.25-.833a2.749,2.749,0,0,0-.583-.042Zm-11.2.416a2.857,2.857,0,0,0-1.624-.416c-1,0-1.665.5-1.665,1.29,0,.666.5,1.041,1.374,1.166l.416.042c.458.083.708.208.708.416,0,.291-.333.5-.916.5a2.3,2.3,0,0,1-1.332-.416l-.416.666a2.944,2.944,0,0,0,1.707.5c1.166,0,1.832-.541,1.832-1.291,0-.708-.541-1.082-1.374-1.207l-.416-.042c-.375-.042-.666-.125-.666-.375,0-.291.291-.458.749-.458a3,3,0,0,1,1.249.333l.375-.708Zm23.229-.416a1.173,1.173,0,0,0-1.041.583v-.5h-.874v4h.874v-2.248c0-.666.291-1.041.833-1.041a2.437,2.437,0,0,1,.541.083l.25-.833a2.749,2.749,0,0,0-.583-.042Zm-11.157,2.081a2,2,0,0,0,2.123,2.082,2.071,2.071,0,0,0,1.415-.458l-.416-.708a1.682,1.682,0,0,1-1.041.375,1.182,1.182,0,0,1-1.207-1.291,1.228,1.228,0,0,1,1.207-1.29,1.682,1.682,0,0,1,1.041.375l.416-.708a2.071,2.071,0,0,0-1.415-.458,2,2,0,0,0-2.123,2.081Zm8.076,0v-2h-.874v.5a1.5,1.5,0,0,0-1.249-.583,2.083,2.083,0,0,0,0,4.163,1.4,1.4,0,0,0,1.249-.583v.5h.874Zm-3.205,0a1.21,1.21,0,1,1,2.415,0,1.21,1.21,0,1,1-2.415,0Zm-10.449-2.081a2.083,2.083,0,0,0,.042,4.163,2.546,2.546,0,0,0,1.624-.541l-.416-.624a1.989,1.989,0,0,1-1.166.416,1.124,1.124,0,0,1-1.207-.957h2.956v-.333a1.839,1.839,0,0,0-1.832-2.123Zm0,.749a.974.974,0,0,1,1,.958H33.892a1.054,1.054,0,0,1,1.082-.958Zm21.689,1.332V168.6h-.874v2.081a1.5,1.5,0,0,0-1.249-.583,2.083,2.083,0,0,0,0,4.163,1.4,1.4,0,0,0,1.249-.583v.5h.874Zm-3.205,0a1.21,1.21,0,1,1,2.415,0,1.21,1.21,0,1,1-2.415,0Zm-29.224,0v-2h-.874v.5a1.5,1.5,0,0,0-1.249-.583,2.083,2.083,0,0,0,0,4.163,1.4,1.4,0,0,0,1.249-.583v.5h.874Zm-3.247,0a1.21,1.21,0,1,1,2.415,0,1.21,1.21,0,1,1-2.415,0Z"
            transform="translate(-10.496 -136.623)"
        />
        <rect
            id="Rectangle_18"
            data-name="Rectangle 18"
            width="13.113"
            height="23.562"
            transform="translate(17.693 3.205)"
            fill="#ff5f00"
        />
        <path
            id="Path_2259"
            data-name="Path 2259"
            d="M18.525,14.987a15.026,15.026,0,0,1,5.7-11.781,14.981,14.981,0,1,0-9.242,26.768,14.9,14.9,0,0,0,9.242-3.205A14.964,14.964,0,0,1,18.525,14.987Z"
            transform="translate(0 0)"
            fill="#eb001b"
        />
        <path
            id="Path_2260"
            data-name="Path 2260"
            d="M152.211,14.987a14.971,14.971,0,0,1-24.229,11.781,15.02,15.02,0,0,0,0-23.562,14.971,14.971,0,0,1,24.229,11.781Z"
            transform="translate(-103.713 0)"
            fill="#f79e1b"
        />
    </svg>
</template>
<script>
export default {
    name: "MasterCard",
};
</script>
